<template>
  <div class="container">
      <div class="content">
        <detail ref="detail" @detail="setDetail" ></detail>
        <div class="footer" :class="[isCollapsed?'footer-collapsed':'']">
          <div class="footer-btn" v-show="detail.status">
            <el-button type="info" plain  @click="$router.go(-1)">返回</el-button>
            <el-button type="primary" v-if="!$root.desktopWorkbench && detail.businessName && detail.businessName !== 'noticeDetail'" plain  @click="lookAccount()">查看账号</el-button>
            <el-button type="primary" v-if="!$root.desktopWorkbench && detail.businessName === 'noticeDetail'" plain  @click="lookAnnouncement()">查看</el-button>
            <el-button type="primary" @click="getPdf('export')" :loading="btnExport">导出</el-button>
            <el-button type="primary" @click="getPdf('print')" :loading="btnPrint">打印</el-button>
          </div>
      </div>
      </div>
  </div>
</template>
<script>
import mixinsDetail from '@/pages/officeApproval/approvalList/mixins/detail.js'
export default {
  name: 'manageApprovalDetail',
  mixins: [mixinsDetail],
  components: {
  },
  data() {
      return {
      }
  },
  created() {
  },
  activated() {
  },
  mounted() {

  },
  methods: {
   
  }
}
</script>
<style scoped lang="scss" src="./mixins/detailLayout.scss"></style>
